export default {
  PROCESSING: 'PROCESSING',
  IN_SHIPMENT: 'IN_SHIPMENT',
  READY_FOR_SHIPMENT: 'READY_FOR_SHIPMENT',
  SHIPPED: 'SHIPPED',
  CANCELED: 'CANCELED',
  SPLIT: 'SPLIT',
  RESHIPMENT: 'RESHIPMENT',
  TRANSFERRED: 'TRANSFERRED',
};
